export default "__VITE_ASSET__B87ZEP1F__"